import type { MouseEventHandler, Ref } from "preact";
import { forwardRef } from "preact/compat";
import type { Icon } from "../components/icons";

interface Parameters {
    active: boolean;
    onClick: MouseEventHandler<HTMLButtonElement>;
    icon: Icon;
}

export const ButtonIcon = forwardRef(
    ({ active, icon, onClick }: Parameters, ref: Ref<HTMLButtonElement>) => {
        const Icon = icon;
        return (
            <button
                type="button"
                ref={ref}
                onClick={onClick}
                className={active ? "active" : undefined}
            >
                <Icon />
            </button>
        );
    },
);

ButtonIcon.displayName = "ButtonIcon";
